import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/scss/vuetify/overrides.scss'
Vue.use(Vuetify);

const theme = {
  primary: '#F87400',
  info: '#F87400',
  success: '#21c1d6',
  accent: '#F87400',
  default: '#563dea'
}

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: true,
  }
});
